export default __webpack_public_path__ + "static/media/Group380.d1bd0d2b.png";